import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import Footerwithdr from "../../../common_components/Footerwithdr";
import {
  getVendorWorkOrderList_action,
  deleteVendorWorkOrder_action,
} from "../../../actions/admin_module_action/vendor_action/vendorWorkOrder_action/vendorWorkOrder_action";
import {
  getVendorPlanList_action,
  getVendorPlanDetail_action,
} from "../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_plan_action";
import { getVendorExhibitionList_action } from "../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_exhibition_list_action";
import {
  exhibitionId,
  serviceTypeId,
  VendorPlanStatusActionId,
  toastError,
  toastSuccess,
} from "../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import * as XLSX from "xlsx";

const styles = {
  width: "100%",
};

class VendorPlan extends Component {
  constructor(props) {
    super(props);
    const userRoleID =
      JSON.parse(sessionStorage.getItem("loginDataSS"))?.RoleID ||
      sessionStorage.getItem("RoleIDSS");
    let defaultStatus = "";
    if (userRoleID == 6 || userRoleID == 24 || userRoleID == 2) {
      defaultStatus = "2";
    } else if (userRoleID == 7 || userRoleID == 17) {
      defaultStatus = "0";
    }

    this.state = {
      isLoading: false,
      workOrderList: [],
      currentPage: 1,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      exhibitionList: [],
      WorkOrderNumber: "",
      PersonName: "",
      ServiceID: "",
      serviceTypeList: [],
      vendorServiceList: [],
      Status: defaultStatus,
      EmailID: "",
      WorkOrderServiceList: [],
      VendorPlanStatusList: [],
      workOrderList: [],
      isOpen: false,
      sortField: "",
      sortOrder: "",
      isVendor: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17,
      hasSearched: false,
      selectedIds: [],
      showVideoModal: false,
      loginAccesslist: []
    };
    this.updateItem = this.updateItem.bind(this);
  }

  componentDidMount() {
    this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
    this.getFillList(exhibitionId, "", "", "", "", "");
    this.getFillList(serviceTypeId, "", "", "", "", "");
    this.getFillList(VendorPlanStatusActionId, "", "", "", "", "");
    this.getVendorExhibitionList();
    this.getVendorPlanList();
  }

  getVendorPlanList() {
    const { ExhibitionID, WorkOrderNumber, ServiceID, Status } = this.state;

    const userRoleID = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;
    let defaultStatus = Status;

    if (Status === "" || Status === "Select") {
      if (userRoleID == 6 || userRoleID == 24 || userRoleID == 2) {
        defaultStatus = 2;
      } else if (userRoleID == 7 || userRoleID == 17) {
        defaultStatus = 0;
      } else {
        defaultStatus = 0;
      }
    }

    this.setState({ isLoading: true });
    try {
      this.props
        .getVendorPlanList_action(
          ExhibitionID,
          WorkOrderNumber,
          ServiceID,
          defaultStatus
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({
              workOrderList:
                data.data.vendorPlanDetails || data.data.vendorPlanList || [],
              hasSearched: Status == 3,
            });
          } else {
            toastError(data.msg);
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch {
      toastError("Something went wrong!");
      this.setState({ isLoading: false });
    }
  }

  deleteWorkOrder() {
    const { WorkOrderID, ExhibitionID } = this.state;
    this.setState({ isLoading: true });
    try {
      this.props
        .deleteVendorWorkOrder_action(WorkOrderID, ExhibitionID)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isOpen: false });
            this.clearValue();
            toastSuccess("Deleted successfully!");
          } else {
            toastError(data.msg);
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch {
      toastError("Something went wrong!");
      this.setState({ isLoading: false });
    }
  }

  updateItem(item) {
    const { workOrderList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = workOrderList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(workOrderList.length / recordsPerPage);
  }

  // get fill List dropdown
  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID
  ) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID
      )
      .then((data) => {
        if (data.error != 1) {
          // voucher list
          if (actionID === exhibitionId) {
            // console.log("voucher type data", data.data)
            this.setState({
              exhibitionList: data.data,
              isLoading: false,
            });
          }
          if (actionID === serviceTypeId) {
            this.setState({
              WorkOrderServiceList: data.data,
              serviceTypeList: data.data,
            });
          }
          if (actionID === VendorPlanStatusActionId) {
            const reorderedList = this.reorderStatusList(data.data);
            this.setState({ VendorPlanStatusList: reorderedList });
            console.log("VendorPlanStatusList", this.state.VendorPlanStatusList);
            console.log("VendorPlanStatusList", reorderedList);
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addWorkOrder() {
    this.props.navigate("/vendorWorkOrderAU", { state: { add: true } });
  }

  updateWorkOrder(WorkOrderID, param) {
    if (param == "replicate") {
      this.props.navigate("/vendorWorkOrderAU", {
        state: {
          update: true,
          isView: false,
          replicate: true,
          WorkOrderID: WorkOrderID,
        },
      });
    } else if (param == "view") {
      this.props.navigate("/vendorWorkOrderAU", {
        state: {
          update: true,
          isView: true,
          replicate: false,
          WorkOrderID: WorkOrderID,
        },
      });
    } else {
      this.props.navigate("/vendorWorkOrderAU", {
        state: {
          update: true,
          isView: false,
          replicate: false,
          WorkOrderID: WorkOrderID,
        },
      });
    }
  }

  openVendorPlanRecord(
    ExhVendorPlanHdrID,
    isReadonly = false,
    workOrderNo = "",
    serviceName = ""
  ) {
    sessionStorage.setItem("selectedVendorPlanId", ExhVendorPlanHdrID);
    sessionStorage.setItem("selectedWorkOrderNo", workOrderNo);
    sessionStorage.setItem("selectedServiceName", serviceName);
    const userRoleID = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;
    if (isReadonly && userRoleID != 6) {
      sessionStorage.setItem("vendorPlanReadonly", "true");
    } else {
      sessionStorage.removeItem("vendorPlanReadonly");
    }
    this.props.getVendorPlanDetail_action(ExhVendorPlanHdrID);
    if (this.props.onNavigateToRecord) {
      this.props.onNavigateToRecord();
    } else {
      this.props.navigate("/vendorPlanRecord");
    }
  }

  getVendorExhibitionList() {
    const { ExhibitionID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getVendorExhibitionList_action(ExhibitionID, "")
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            vendorServiceList: data.data.serviceList || [],
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  reorderStatusList(statusList) {
    const order = [1, 4, 2, 3]; // Pending, Save As Draft, Submitted, Approved
    return order.map(id => statusList.find(item => item.VendorPlanStatusID === id)).filter(Boolean);
  }

  clearValue() {
    this.setState({
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      WorkOrderNumber: "",
      PersonName: "",
      ServiceID: "",
      EmailID: "",
      Status: "0",
      currentPage: 1,
      hasSearched: false,
      selectedIds: [],
    }, () => {
      this.getVendorPlanList();
    });
  }

  handleSelectAll = (e) => {
    const { currentRecords } = this.state;
    if (e.target.checked) {
      this.setState({ selectedIds: currentRecords.map(item => item.ExhVendorPlanHdrID) });
    } else {
      this.setState({ selectedIds: [] });
    }
  };

  handleSelectRow = (id) => {
    const { selectedIds } = this.state;
    if (selectedIds.includes(id)) {
      this.setState({ selectedIds: selectedIds.filter(item => item !== id) });
    } else {
      this.setState({ selectedIds: [...selectedIds, id] });
    }
  };

  exportSelectedToExcel = () => {
    const { selectedIds } = this.state;
    if (selectedIds.length === 0) {
      toastError("Please select at least one record to export");
      return;
    }
    this.setState({ isLoading: true });
    try {
      this.props
        .getVendorPlanDetail_action(selectedIds.join(','))
        .then((data) => {
          if (data.error != 1 && data.data && data.data.vendorPlanDetails) {
            const exportData = data.data.vendorPlanDetails.map(item => ({
              "Company Name": item.CompanyName || "-",
              "Work Order Number": item.WorkOrderNumber || "-",
              "Service": item.ServiceName || "-",
              "Deliverables": item.DeliverablesServiceName || "-",
              "Hall Name": item.HallName || "-",
              "Start Time": item.StartTime || "-",
              "End Time": item.EndTime || "-",
              "Status": item.IsCompleted ? "Completed" : "Pending"
            }));
            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Vendor Plan Details");
            XLSX.writeFile(wb, `VendorPlanDetails.xlsx`);
          } else {
            toastError(data.msg || "No data to export");
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
          toastError("Export failed");
          this.setState({ isLoading: false });
        });
    } catch (err) {
      console.log(err);
      toastError("Export failed");
      this.setState({ isLoading: false });
    }
  };

  formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${day}-${month}-${year}, ${hours}:${minutes}:${seconds}`;
  };

  // Plan submission due date shown on top of the list - DD-MM-YYYY HH:mm
  formatSubmissionDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  handleSort = (field) => {
    const { sortField, sortOrder, workOrderList } = this.state;
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";

    const sortedData = [...workOrderList].sort((a, b) => {
      const aVal = a[field];
      const bVal = b[field];

      // Handle numbers vs strings
      if (typeof aVal === "number" && typeof bVal === "number") {
        return newSortOrder === "asc" ? aVal - bVal : bVal - aVal;
      }

      const aStr = (aVal || "").toString().toLowerCase();
      const bStr = (bVal || "").toString().toLowerCase();

      if (aStr < bStr) return newSortOrder === "asc" ? -1 : 1;
      if (aStr > bStr) return newSortOrder === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      workOrderList: sortedData,
      sortField: field,
      sortOrder: newSortOrder,
    });
  };

  getWriteAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '81');
    if (moduleAccess) {
      return moduleAccess.WriteAccess;
    } else {
      return false
    }
    return false;
  }

  getUpdateAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '81');
    if (moduleAccess) {
      return moduleAccess.UpdateAccess;
    } else {
      return false
    }
    return false;
  }

  getDeleteAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '81');
    if (moduleAccess) {
      return moduleAccess.DeleteAccess;
    } else {
      return false
    }
    return false;
  }

  getDownloadAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '81');
    if (moduleAccess) {
      return moduleAccess.DownloadAccess;
    } else {
      return false
    }
    return false;
  }

  getSendAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '81');
    if (moduleAccess) {
      return moduleAccess.SendAccess;
    } else {
      return false
    }
    return false;
  }


  getSpecialAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '81');
    if (moduleAccess) {
      return moduleAccess.Is_SpecialAccess;
    } else {
      return false
    }
    return false;
  }

  // Single source of truth for the action column - both the column header and the row icons are
  // built from this list, so adding an action here is enough to get it into the header as well
  getRowActions() {
    const isRoleID6 =
      JSON.parse(sessionStorage.getItem("loginDataSS"))?.RoleID == 6 ||
      JSON.parse(sessionStorage.getItem("loginDataSS"))?.RoleID == 24 ||
      JSON.parse(sessionStorage.getItem("loginDataSS"))?.RoleID == 2 ||
      sessionStorage.getItem("RoleIDSS") == 6 ||
      sessionStorage.getItem("RoleIDSS") == 24 ||
      sessionStorage.getItem("RoleIDSS") == 2;
    const isReadonlyRow = (data) =>
      Boolean(data.ApprovedDate) && !isRoleID6 && this.getWriteAccess();

    return [
      {
        label: "View Plan",
        iconClass: "fa fa-eye grid-icon",
        isVisible: (data) => isReadonlyRow(data),
        onClick: (data) =>
          this.openVendorPlanRecord(
            data.ExhVendorPlanHdrID,
            true,
            data.WorkOrderNumber || data.WorkOrderNo,
            data.ServiceName || data.DeliverablesServiceName
          ),
      },
      {
        label: "Edit Plan",
        iconClass: "fa fa-edit grid-icon",
        isVisible: (data) => !isReadonlyRow(data),
        onClick: (data) =>
          this.openVendorPlanRecord(
            data.ExhVendorPlanHdrID,
            false,
            data.WorkOrderNumber || data.WorkOrderNo,
            data.ServiceName || data.DeliverablesServiceName
          ),
      },
    ];
  }

  render() {
    const {
      isLoading,
      ExhibitionID,
      WorkOrderNumber,
      PersonName,
      ServiceID,
      currentPage,
      exhibitionList,
      EmailID,
      Status,
      WorkOrderServiceList,
      VendorPlanStatusList,
      workOrderList,
      isOpen,
      isVendor,
      serviceTypeList,
      vendorServiceList,
      hasSearched,
      selectedIds, showVideoModal
    } = this.state;

    // Create vendorServiceListArr exactly like vendor_exhibition_list
    var vendorServiceListArr = [];
    vendorServiceList.length > 0 &&
      vendorServiceList.forEach((item) => {
        for (var i = 0; i < serviceTypeList.length; i++) {
          if (serviceTypeList[i].ServiceID == item.ServiceID) {
            vendorServiceListArr.push(serviceTypeList[i]);
            break;
          }
        }
      });

    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = isVendor ? workOrderList : workOrderList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(workOrderList.length / recordsPerPage);
    this.state.currentRecords = currentRecords;

    console.log("currentRecords", currentRecords);

    // The submission due date is the same for the whole plan, so the first
    // record that carries it drives the banner
    const planSubmissionDate = this.formatSubmissionDate(
      workOrderList.find((item) => item.PlanSubmissionDate)?.PlanSubmissionDate
    );

    // Action column header is built from the tooltips of the action icons this user can actually see
    const rowActions = this.getRowActions();
    const visibleActions = rowActions.filter((action) =>
      currentRecords.some((data) => action.isVisible(data))
    );
    const actionHeader =
      visibleActions.length > 0
        ? visibleActions.map((action) => action.label).join("/")
        : "Edit";

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {isVendor && showVideoModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
            <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Plan And Timeline</h5>
                  <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                </div>
                <div className="modal-body">
                  <video controls autoPlay style={{ width: '100%' }}>
                    <source src="/assets/VendorPlan&Timeline.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        {!isVendor &&
          (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorDrawer />
          ) : (
            <AdminDrawer />
          ))}
        <div
          className={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? "with-dr-container"
              : "with-dr-container com-height"
          }
          style={{ margin: isVendor ? 0 : "" }}
        >
          <div
            className={`main-content ${!isVendor ? "app-content p-0" : "mt-0"}`}
            style={{ margin: isVendor ? 0 : "" }}
          >
            {(!isVendor && JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID !== 7 && JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID !== 17) && (
              <div class="row m-0">
                <div className="breadcrumb-scroll-fixed">
                  <h6 className="mb-0 p-2 text-white">Plan & Timeline List</h6>
                </div>
              </div>
            )}
            <div class="admin-top-space px-3 pt-0">
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                <ExhibitorTopMenu />
              ) : null}

              {isVendor && (
                <div className="d-flex justify-content-end p-3 pb-0">
                  {/* <span
                  onClick={() => this.setState({ showVideoModal: true })}
                  style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px', marginLeft: 'auto' }}>
                  <i className="bi bi-play-circle-fill me-2"></i>User Manual
                </span> */}
                </div>
              )}

              {planSubmissionDate && (
                <div className="row">
                  <div className="col-12 pb-2">
                    <h6 className="text-danger fw-semibold mb-0">
                      Plan Submission Date : {planSubmissionDate}
                    </h6>
                  </div>
                </div>
              )}

              <div class="row align-items-end">
                <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
                  <label>Work Order No</label>
                  <input
                    type="text"
                    className="form-control"
                    value={WorkOrderNumber}
                    onChange={(e) =>
                      this.setState({ WorkOrderNumber: e.target.value })
                    }
                    placeholder="Enter Work Order Number"
                  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
                  <label>Service Type</label>
                  <select
                    className="form-control"
                    id="roledb"
                    value={ServiceID}
                    onChange={(e) => this.setState({ ServiceID: e.target.value })}
                  >
                    <option>Select</option>
                    {vendorServiceListArr.length > 0 &&
                      vendorServiceListArr.map((data) => (
                        <option key={data.ServiceID} value={data.ServiceID}>
                          {data.Name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-2 col-lg-2 col-md-6 mb-3">
                  <label>Status</label>
                  <select
                    className="form-control"
                    id="roledb"
                    value={Status}
                    onChange={(e) => this.setState({ Status: e.target.value })}
                  >
                    <option value="">Select</option>
                    {VendorPlanStatusList.length > 0 &&
                      VendorPlanStatusList.map((data) => (
                        <option
                          key={data.VendorPlanStatusID}
                          value={data.VendorPlanStatusID}
                          style={{ textTransform: "none" }}
                        >
                          {data.Name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 mb-3 d-flex justify-content-start justify-content-lg-end align-items-end">
                  <div className="d-flex flex-nowrap gap-2 w-100 justify-content-lg-end">
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={(e) => this.getVendorPlanList()}
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-gray"
                      onClick={(e) => this.clearValue()}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={(e) => this.exportSelectedToExcel()}
                      disabled={(!hasSearched || workOrderList.length === 0 || this.state.selectedIds.length === 0) && !this.getDownloadAccess()}
                    >
                      {/* <i className="fa fa-file-excel-o me-1"></i> */}
                      Export
                    </button>
                  </div>
                </div>
                {/* </div> */}
              </div>
              {/* {!isVendor && (
              <div class="row mt-1 pb-0 p-2">
                <div className="col-md-3">
                  <label>Exhibition</label>
                  <select
                    className="form-control"
                    id="roledb"
                    value={ExhibitionID}
                    onChange={(e) =>
                      this.setState({ ExhibitionID: e.target.value })
                    }
                  >
                    <option>Select</option>
                    {exhibitionList.length > 0 &&
                      exhibitionList.map((data) => (
                        <option
                          key={data.ExhibitionID}
                          value={data.ExhibitionID}
                        >
                          {data.ExhibitionName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-3 mb-3">
                  <label>Work Order Number</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={WorkOrderNumber}
                    onChange={(e) =>
                      this.setState({ WorkOrderNumber: e.target.value })
                    }
                  />
                </div>
                <div className="col-xl-6 mb-3">
                  <label>Services</label>
                  <Select
                    className="text-left"
                    options={WorkOrderServiceList.map((option) => ({
                      label: option.Name,
                      value: option.ServiceID,
                    }))}
                    value={ServiceID}
                    onChange={(e) => this.setState({ ServiceID: e })}
                    isMulti
                  />
                </div>
                <div className="col-xl-3 mb-3">
                  <label>Person Name</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={PersonName}
                    onChange={(e) =>
                      this.setState({ PersonName: e.target.value })
                    }
                  />
                </div>
                <div className="col-xl-3 mb-3">
                  <label>Email ID</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={EmailID}
                    onChange={(e) => this.setState({ EmailID: e.target.value })}
                  />
                </div>
                <div className="col-md-3">
                  <label>Status</label>
                  <select
                    className="form-control"
                    id="roledb"
                    value={Status}
                    onChange={(e) =>
                      this.setState({
                        Status: e.target.value,
                      })
                    }
                  >
                    <option value={""}>Select</option>
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                </div>
              </div>
            )} */}

              {/* {!isVendor && (
              <div className="row">
                <div className="col-md-12">
                  <div
                    className="mb-1"
                    role="group"
                    aria-label="Basic example"
                    style={{ float: "right" }}
                  >
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={(e) => this.getVendorPlanList()}
                    >
                      Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={(e) => this.clearValue()}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={() => this.addWorkOrder()}
                    >
                      Add Scope of work
                    </button>
                  </div>
                </div>
              </div>
            )} */}
              <div className="row m-0">
                <div
                  className="table-responsive px-0 sticky-table-wrapper service-list-grid vendor-plan-grid mt-2"
                  style={{ maxHeight: "calc(100vh - 310px)", overflowY: "auto" }}
                >
                  <table className="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                    <thead class="table-light">
                      <tr>
                        <th className="text-center" style={{ width: "50px" }}>
                          <input className="m-0"
                            type="checkbox"
                            onChange={this.handleSelectAll}
                            checked={this.state.selectedIds.length > 0 && this.state.selectedIds.length === currentRecords.length}
                          />
                        </th>
                        <th>
                          <div className="icons-shorting">
                            Work Order No
                            {/* <span
                          className="mx-1"
                          onClick={() => this.handleSort("WorkOrderNumber")}
                        >
                          <i className="fa fa-long-arrow-up"></i>
                          <i className="fa fa-long-arrow-down"></i>
                        </span> */}
                          </div>
                        </th>
                        {!isVendor && (
                          <th>
                            <div className="icons-shorting">
                              Service Partner
                              {/* <span
                            class="mx-1"
                            onClick={() => this.handleSort("VendorCompanyName")}
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span> */}
                            </div>
                          </th>
                        )}
                        <th>
                          <div className="icons-shorting">
                            Service
                            {/* <span
                          class="mx-1"
                          onClick={() => this.handleSort("WorkOrderServices")}
                        >
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span> */}
                          </div>
                        </th>
                        <th>
                          <div className="icons-shorting">
                            Status
                            {/* <span
                          class="mx-1"
                          onClick={() => this.handleSort("PersonName")}
                        >
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span> */}
                          </div>
                        </th>
                        <th>
                          <div className="icons-shorting">
                            Submitted Date Time
                            {/* <span
                          class="mx-1"
                          onClick={() => this.handleSort("EmailID")}
                        >
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span> */}
                          </div>
                        </th>
                        <th>
                          <div className="icons-shorting">
                            Approved By
                            {/* <span
                          class="mx-1"
                          onClick={() => this.handleSort("EmailID")}
                        >
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span> */}
                          </div>
                        </th>
                        <th>
                          <div className="icons-shorting">
                            Approved Date Time
                            {/* <span
                          class="mx-1"
                          onClick={() => this.handleSort("MobileNumber")}
                        >
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span> */}
                          </div>
                        </th>
                        <th className="text-center">  <span>  {actionHeader}</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.length > 0 && currentRecords != null ? (
                        currentRecords.map((data, i) => (
                          <tr>
                            <td className="text-center">
                              <input className="m-0"
                                type="checkbox"
                                checked={this.state.selectedIds.includes(data.ExhVendorPlanHdrID)}
                                onChange={() => this.handleSelectRow(data.ExhVendorPlanHdrID)}
                              />
                            </td>
                            <td>
                              {data.WorkOrderNumber || data.WorkOrderNo || "-"}
                            </td>
                            {!isVendor && (
                              <td>
                                {data.VendorName || data.VendorCompanyName || "-"}
                              </td>
                            )}
                            <td>
                              {data.ServiceName ||
                                data.DeliverablesServiceName ||
                                "-"}
                            </td>
                            <td className="text-success">
                              {data.StatusName || data.Status || "Active"}
                            </td>
                            <td>
                              {this.formatDate(
                                data.SubmittedDate || data.CreatedDate
                              ) || "-"}
                            </td>
                            <td>
                              {data.ApprovedBy ||
                                data.ApprovedBy ||
                                "-"}
                            </td>
                            <td>
                              {this.formatDate(
                                data.ApprovedDate || data.ModifiedDate
                              ) || "-"}
                            </td>
                            <td className="text-center act-col">
                              {rowActions
                                .filter((action) => action.isVisible(data))
                                .map((action) => (
                                  <a
                                    key={action.label}
                                    role="button"
                                    title={action.label}
                                    className="d-inline-block px-2 py-1"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => action.onClick(data)}
                                  >
                                    <i className={action.iconClass} />
                                  </a>
                                ))}
                              {/* {!isVendor && (
                            <>
                              <span style={{ color: "#ccc" }}> | </span>
                              <i
                                className="fa fa-trash text-danger mx-1"
                                title="Delete Scope of work"
                                onClick={() =>
                                  this.setState({
                                    isOpen: true,
                                    ExhVendorPlanHdrID: data.ExhVendorPlanHdrID,
                                    ExhibitionID: data.ExhibitionID,
                                  })
                                }
                              />
                            </>
                          )} */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            Record not found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {!isVendor && (
                    <div className="table-pagination-footer">
                      <div>
                        {workOrderList.length > 0 ? (
                          <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={this.updateItem}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="table-pagination-info">
                        <p>{`${currentPage} of ${nPages} pages`}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {!isVendor && (
          <Footerwithdr />
        )}
        <Modal
          isOpen={isOpen}
          onRequestClose={() => this.setState({ isOpen: false })}
        >
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header text-right p-2">
                <h5 class="modal-title">
                  Do you really want to delete this record?
                </h5>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-aqua"
                    onClick={(e) => this.deleteWorkOrder()}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ isOpen: false })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    getVendorWorkOrderList_action,
    deleteVendorWorkOrder_action,
    getVendorPlanList_action,
    getVendorPlanDetail_action,
    getVendorExhibitionList_action,
  })(VendorPlan)
);
